import React from "react";

const ProficiencyLevel = () => {
  return <div>Proficiency Level Content</div>;
};

export default ProficiencyLevel;
